module.exports = __webpack_public_path__ + "static/media/Parth_Mane.c55d3f88.jpg";